module.exports = __webpack_public_path__ + "assets/static/png/games-red.2f646e54afb463459c99861d9ad95987.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/games-red.png
 ** module id = 506
 ** module chunks = 1
 **/